import { criteriaConfig } from '@/constants/CampaignCriteria';

export const formatCriteriaValue = (option, value, products, translate) => {
    const config = criteriaConfig[option];
    if (!config) return { type: 'simple', value };

    switch (config.type) {
        case 'number': {
            const formattedValue = config.adornment ? `${value} ${config.adornment}` : `${value}`;
            return {
                type: 'simple',
                value: formattedValue,
            };
        }
        case 'singleProduct':
            if (value && typeof value === 'object') {
                return { type: 'simple', value: value?.name || translate('common.noProductSelected') };
            }
            if (value !== undefined && value !== null) {
                const product = products.find(p => `${p.id}` === `${value}`);
                return { type: 'simple', value: product?.name || translate('common.noProductSelected') };
            }
            return { type: 'simple', value: translate('common.noProductSelected') };
        case 'categories':
            if (Array.isArray(value) && value.length > 0) {
                return { type: 'categories', value, categoryIds: value };
            }
            return { type: 'simple', value: translate('common.noCategoriesSelected') };
        case 'radio':
            return {
                type: 'simple',
                value: config.options?.find(opt => opt.value === value)?.label || value,
            };
        case 'timeRange':
            return { type: 'simple', value: value || translate('common.notSet') };
        default:
            return { type: 'simple', value };
    }
};
